import { ExplanationTypeEnum } from '@doltech/utils/lib/constants';

export const getTitle = (explanation) => {
  if (explanation.type === ExplanationTypeEnum.MAIN_IDEA) {
    return 'Simplify & Connection';
  }
  return 'Paraphrasing';
};

export const getInitValue = (explanation) => {
  if (explanation.type === ExplanationTypeEnum.MAIN_IDEA) {
    return explanation?.simplify;
  }
  return explanation?.paraphrasing;
};
